import React, { useState } from 'react';
import { useOrders } from '../contexts/OrderContext';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { StatusBadge } from '../components/ui/StatusBadge';
import { DimensionsModal } from '../components/DimensionsModal';
import { Play, Check, Ruler } from 'lucide-react';
import { storage } from '../utils/storage';
export function CleaningManagementPage() {
  const {
    getOrdersByStatus,
    updateOrderStatus,
    orders,
    refreshData
  } = useOrders();
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const receivedOrders = getOrdersByStatus('RECUE_DEPOT');
  const waitingOrders = getOrdersByStatus('ATTENTE_NETTOYAGE');
  const inProgressOrders = getOrdersByStatus('EN_COURS_NETTOYAGE');
  const handleStartCleaning = async (order: any) => {
    if (window.confirm('Démarrer le nettoyage de cette commande ?')) {
      await updateOrderStatus(order.id, 'EN_COURS_NETTOYAGE', 'Démarrage nettoyage');
    }
  };
  const handleFinishCleaning = (order: any) => {
    // If it's a carpet (TAPIS), require dimensions
    if (order.type === 'TAPIS') {
      setSelectedOrder(order);
      setIsDimensionsModalOpen(true);
    } else {
      // For HOUSSE, directly finish
      finishCleaningWithoutDimensions(order);
    }
  };
  const finishCleaningWithoutDimensions = async (order: any) => {
    if (window.confirm('Terminer le nettoyage de cette commande ?')) {
      await updateOrderStatus(order.id, 'NETTOYAGE_TERMINE', 'Fin nettoyage');
    }
  };
  const handleDimensionsConfirm = async (dimensions: string) => {
    if (!selectedOrder) return;
    // Update order with dimensions
    const allOrders = storage.getOrders();
    const orderIndex = allOrders.findIndex(o => o.id === selectedOrder.id);
    if (orderIndex !== -1) {
      allOrders[orderIndex] = {
        ...allOrders[orderIndex],
        dimensions: dimensions,
        updatedAt: new Date().toISOString()
      };
      storage.saveOrder(allOrders[orderIndex]);
    }
    // Update status
    await updateOrderStatus(selectedOrder.id, 'NETTOYAGE_TERMINE', `Fin nettoyage - Dimensions: ${dimensions}`);
    setSelectedOrder(null);
  };
  const OrderRow = ({
    order,
    action
  }: {
    order: any;
    action: React.ReactNode;
  }) => <div className="flex items-center justify-between p-4 border-b border-gray-100 last:border-0 hover:bg-gray-50" data-id="element-286">
      <div className="flex-1" data-id="element-287">
        <div className="font-medium text-gray-900" data-id="element-288">
          {order.id} - {order.clientName}
        </div>
        <div className="text-sm text-gray-500 flex items-center gap-2" data-id="element-289">
          <span data-id="element-290">
            {order.type} (Qté: {order.quantity})
          </span>
          {order.type === 'TAPIS' && order.dimensions && <span className="inline-flex items-center text-xs bg-blue-50 text-blue-700 px-2 py-0.5 rounded" data-id="element-291">
              <Ruler className="w-3 h-3 mr-1" data-id="element-292" />
              {order.dimensions}
            </span>}
        </div>
      </div>
      <div className="flex items-center gap-3" data-id="element-293">
        <StatusBadge status={order.status} data-id="element-294" />
        {action}
      </div>
    </div>;
  return <div className="space-y-8" data-id="element-295">
      <h1 className="text-2xl font-bold text-gray-900" data-id="element-296">Gestion du Nettoyage</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-297">
        {/* Queue: To Start */}
        <Card title={`File d'attente (${receivedOrders.length + waitingOrders.length})`} data-id="element-298">
          <div className="divide-y divide-gray-100" data-id="element-299">
            {[...receivedOrders, ...waitingOrders].length === 0 && <p className="text-gray-500 text-center py-4" data-id="element-300">
                Aucune commande en attente
              </p>}
            {[...receivedOrders, ...waitingOrders].map(order => <OrderRow key={order.id} order={order} action={<Button size="sm" onClick={() => handleStartCleaning(order)} className="bg-orange-500 hover:bg-orange-600 text-white" data-id="element-302">
                    <Play className="w-4 h-4 mr-1" data-id="element-303" /> Démarrer
                  </Button>} data-id="element-301" />)}
          </div>
        </Card>

        {/* Queue: In Progress */}
        <Card title={`En Cours (${inProgressOrders.length})`} data-id="element-304">
          <div className="divide-y divide-gray-100" data-id="element-305">
            {inProgressOrders.length === 0 && <p className="text-gray-500 text-center py-4" data-id="element-306">
                Aucun nettoyage en cours
              </p>}
            {inProgressOrders.map(order => <OrderRow key={order.id} order={order} action={<Button size="sm" onClick={() => handleFinishCleaning(order)} className="bg-green-600 hover:bg-green-700 text-white" data-id="element-308">
                    <Check className="w-4 h-4 mr-1" data-id="element-309" /> Terminer
                  </Button>} data-id="element-307" />)}
          </div>
        </Card>
      </div>

      {/* Dimensions Modal */}
      {selectedOrder && <DimensionsModal isOpen={isDimensionsModalOpen} onClose={() => {
      setIsDimensionsModalOpen(false);
      setSelectedOrder(null);
    }} onConfirm={handleDimensionsConfirm} orderInfo={{
      id: selectedOrder.id,
      clientName: selectedOrder.clientName,
      quantity: selectedOrder.quantity
    }} data-id="element-310" />}
    </div>;
}